'use client';
import { NextPage } from 'next';
import React, { useMemo, useState } from 'react';
import Button from './Button';
import { shallow } from 'zustand/shallow';
import useOnboardingFormStore from '../../dashboard/stores/useOnboardingFormStore';
import { OnboardingFormComponentProps } from '../utils/types';
import { useRouter } from 'next/navigation';
import useDashboardStore from '../../dashboard/stores/useDashboardStore';

const MyProduct: NextPage<OnboardingFormComponentProps> = ({ currentStep, setCurrentStep, submitedForms, setSubmitedForms }) => {
    const router = useRouter();
    const [steps, setCurrentStepToStore] = useOnboardingFormStore((state) => [state.steps, state.setCurrentStepToStore], shallow);
    const [resetProductsFetchingState] = useDashboardStore((state) => [state.resetProductsFetchingState], shallow)
    const [loading, setLoading] = useState<{addMyProduct: boolean, maybeLater: boolean}>({addMyProduct: false, maybeLater: false});

    const handleAddMyProduct = async () => {
        setLoading({ ...loading, addMyProduct: true});
        setSubmitedForms([...submitedForms, currentStep]);
        await setCurrentStepToStore({ id: currentStep, data: {}, isSubmited: true });
        resetProductsFetchingState();
        router.push('/dashboard?view=products&addProduct=true&productType=standard&pageType=onboarding');
    };

    return (
        <div className="flex flex-col gap-4 w-3/4">
            <h1 className="text-kartiv-gray-900 text-2xl font-semibold">Start your journey with your first standard product</h1>
            <p className="text-gray-600">
            By adding your first Standard product to Kartiv, you can utilize our platform right away. Transform your front-facing product image into powerful visuals that speak to your audience. Get started now!
            </p>
            <div className="pt-4 flex gap-3">
                <Button disabled={loading.addMyProduct || loading.maybeLater} label="Add My Product" onClick={handleAddMyProduct} isArrow loading={loading.addMyProduct} />
            </div>
        </div>
    );
};

export default MyProduct;